import { render, staticRenderFns } from "./TeacherDetailsForm.vue?vue&type=template&id=debdc030&"
import script from "./TeacherDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./TeacherDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports